// extracted by mini-css-extract-plugin
module.exports = {"Speaker":"Speaker_Featured_Speaker__aIkap","SpeakerText":"Speaker_Featured_SpeakerText__k2pMR","Image":"Speaker_Featured_Image__YbVnv"};